import React, {useState, useEffect} from 'react'
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { createNewStaff, editStaff, getRiskEntities } from '../../services/request.service';
import { NavLink, useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { deletePersonalToEdit } from '../../reducers/actions/request-actions';
import {format, parseISO} from 'date-fns';

const PersonalForm = () => {

  const navigate = useNavigate();
  const dispatch = useDispatch();
  const personal = useSelector((state)=>state.personal.editPersonal)
  const auth = useSelector((state) => state.auth.user.id);
  
  const [Arl, setArl] = useState([]);
    const [personalData, setPersonalData] = useState({
      identification: personal?.identification || "",
      name: personal?.name || "",
      birthDate: personal === null ? "" : format(new Date(personal?.birthDate), "yyyy-MM-dd") || "",
      rh: personal?.rh || "",
      expeditionDate: personal === null ? ""  : format(new Date(personal?.expeditionDate), 'yyyy-MM-dd') || "",
      riskEntityId: personal?.riskEntityId || "",
      userId: auth,
    });

    const handleInputChange = (e) => {
      setPersonalData({
        ...personalData,
        [e.target.name]: e.target.value,
      });
    };

    const Rh = [
      { value: 1, label: "A+" },
      { value: 2, label: "O+" },
      { value: 3, label: "B+" },
      { value: 4, label: "AB+" },
      { value: 5, label: "A-" },
      { value: 6, label: "O-" },
      { value: 7, label: "B-" },
      { value: 8, label: "AB-" },
    ];

    const {
      register,
      handleSubmit,
      formState: { errors },
    } = useForm();

    useEffect(() => {
      (async () => {
        const data = await getRiskEntities();
        setArl(data);
      })();
    }, []);

    const idPersonal = personal?.id

    const handleSave = async () => {
      if(personal !== null){
        await editStaff(idPersonal, personalData)
        dispatch(deletePersonalToEdit())
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Personal editado',
          showConfirmButton: false,
          timer: 1500
        })
        navigate('/request/personal')
      }else{
        await createNewStaff(personalData)
        setPersonalData({
          identification: "",
          name: "",
          birthDate: "",
          rh: "",
          expeditionDate: "",
          riskEntityId: "",
          userId: auth
        })
        dispatch(deletePersonalToEdit())
        Swal.fire({
          position: 'center',
          icon: 'success',
          title: 'Personal guardado con exito',
          showConfirmButton: false,
          timer: 1500
        })
      }
    }

  return (
    <div>
      <form className="row g-3" onSubmit={handleSubmit(handleSave)}>
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <h4 className="Request-form-h4">{"Personal"}</h4>
          <NavLink to={"/request/personal"} className="btn btn-success" onClick={()=>dispatch(deletePersonalToEdit())}>
            Mi Personal
          </NavLink>
        </div>
        <hr className="Request-hr"></hr>
        <div className="mb-3 row">
          <label htmlFor="identification" className="col-sm-4 col-form-label">
            Identificación
          </label>
          <div className="col-sm-8">
            <input
              name="identification"
              type="Number"
              className="form-control"
              id="Id"
              placeholder="Numero de identificacion"
              {...register("identification", {
                required: "Ingrese un numero de identificacion.",
              })}
              onChange={handleInputChange}
              value={personalData.identification}
            />
            {errors?.identification && (
              <span className="danger">{errors.identification.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="name" className="col-sm-4 col-form-label">
            Nombre
          </label>
          <div className="col-sm-8">
            <input
              name="name"
              type="text"
              className="form-control"
              placeholder="Nombre completo"
              {...register("name", {
                required: "Ingrese el nombre de la persona que ingresara.",
              })}
              onChange={handleInputChange}
              value={personalData.name}
            />
            {errors?.name && (
              <span className="danger">{errors.name.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="birthDate" className="col-sm-4 col-form-label">
            Fecha de nacimiento
          </label>
          <div className="col-sm-8">
            <input
              name="birthDate"
              type="date"
              className="form-control"
              id="birthDate"
              {...register("birthDate", {
                required: "Ingrese la fecha de nacimiento.",
              })}
              onChange={handleInputChange}
              value={personalData.birthDate}
            />
            {errors?.birthDate && (
              <span className="danger">{errors.birthDate.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="expeditionDate" className="col-sm-4 col-form-label">
            Fecha de expedición
          </label>
          <div className="col-sm-8">
            <input
              name="expeditionDate"
              type="date"
              className="form-control"
              {...register("expeditionDate", {
                required: "Ingrese la fecha de expedicion del documento.",
              })}
              onChange={handleInputChange}
              value={personalData.expeditionDate}
            />
            {errors?.expeditionDate && (
              <span className="danger">{errors.expeditionDate.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="rh" className="col-sm-4 col-form-label">
            RH
          </label>
          <div className="col-sm-8">
            <select
              name="rh"
              className="form-select"
              {...register("rh", { required: "Seleccione un grupo sanguineo" })}
              onChange={handleInputChange}
              value={personalData.rh}
            >
              <option label="Seleccione un grupo sanguineo" value="" disabled />
              {Rh.map((option, index) => (
                <option key={index} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
            {errors?.rh && (
              <span className="danger">{errors.rh.message}</span>
            )}
          </div>
        </div>
        <div className="mb-3 row">
          <label htmlFor="riskEntityId" className="col-sm-4 col-form-label">
            ARL
          </label>
          <div className="col-sm-8">
            <select
              name="riskEntityId"
              className="form-select"
              {...register("riskEntityId", {
                required: "Seleccione una entidad de riesgo",
              })}
              onChange={handleInputChange}
              value={personalData.riskEntityId}
            >
              <option
                label="Seleccione una entidad de riesgo"
                value=""
                disabled
              />
              {Arl?.map((option, index) => (
                <option key={index} value={option.id}>
                  {option.name}
                </option>
              ))}
            </select>
            {errors?.riskEntityId && (
              <span className="danger">{errors.riskEntityId.message}</span>
            )}
          </div>
        </div>
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          <button className="btn btn-success btn-sm">Guardar</button>
        </div>
      </form>
    </div>
  );
}


export default PersonalForm